import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setCurrentNavPage } from 'actions';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import _ from 'i18n';
import EventDataTable from '../../components/Admin/EventStats/EventDataTable';
import EventRegistrantLineChart from '../../components/Admin/EventStats/EventRegistrantLinechart/EventRegistrantLineChart';
import FacturationStats from '../../components/Admin/EventStats/Facturation/FacturationStats';
import PeriodFilterEvent from '../../components/Filters/EventStats/PeriodFilterEvent';

const EventStatisticsPage = ({ setCurrentNavPage }) => {
  useEffect(() => {
    setCurrentNavPage('STATISTICS');
  }, []);

  return (
    <div style={{ backgroundColor: '#F4F7F9' }}>
      <PageHeader
        header={_('stats') + ' EVENT'}
        subHeader={_('EN QUELQUES CHIFFRES')}
        icon="STATISTICS_HEADER"
        periodFilter={'true'}
      >
        <div className={'flex items-center'}>
          <PeriodFilterEvent />
        </div>
      </PageHeader>
      <div className="event-stats-container">
        <EventRegistrantLineChart />
        <FacturationStats />
        <EventDataTable />
      </div>
    </div>
  );
};

const mapDispatchToProps = { setCurrentNavPage };

export default connect(null, mapDispatchToProps)(EventStatisticsPage);



// WEBPACK FOOTER //
// ./app/pages/Admin/EventStatisticsPage.js